import React, { FC, useEffect, useState } from "react";
import { Row, Collapse } from "antd";
import { cloneDeep } from "lodash";

import ProgressCardDesc from "@pages/member-details/progress-with-desc";
import PinUnpin from "@pages/member-details/pin-unpin-component";
import CustomTooltip from "@pages/tool-tip";

const { Panel } = Collapse;

const DiseasBasedRisk: FC<any> = (props) => {

  const dataCardId = "27";

  const [activeCardPanel, setActiveCardPanel] = useState<any[]>(props?.activeKey?.includes(dataCardId) ? ["1"] : []);

  useEffect(()=>{
    console.log("DiseasBasedRisk.useEffect");
    setActiveCardPanel(props.activeKey?.includes(dataCardId) ? ["1"] : [])  
  }, [props.activeKey])

  const onCollapseChange = () => {
    if(activeCardPanel.length > 0){
      props.setActivePanels(cloneDeep(props?.activeKey)?.filter((item:any) => item !== dataCardId))
    }
    else {
      props.setActivePanels([...(props?.activeKey ? props?.activeKey : []), dataCardId]);
    }
  }

  const diseasBasedRiskFactors = Object.values(
    props?.data?.chdScore?.topContributingFactors
      ? props?.data?.chdScore?.topContributingFactors
      : {}
  );
  const genExtra = (id: any) => (
    <PinUnpin
      marginRight={"16px"}
      dataCardId={id}
      changeHandler={props?.pinChangeHandler}
      pinCardIds={props.pinCardIds}
    />
  );

  const getHeading = (headerValue: any) => (
    <>
      <span>{headerValue}</span>
      <CustomTooltip
        toolTipvalue={headerValue}
        children={
          <span
            style={{ margin: "8px" }}
            className="icon icon-info clr-lightGrayColor"
          ></span>
        }
      />
    </>
  );

  return (
    <>
      <Collapse
        accordion
        activeKey={activeCardPanel}
        expandIconPosition="right"
        bordered={false}
        onChange={onCollapseChange}
      >
        <Panel
          className="title"
          header={getHeading("Disease Based Risk (1)")}
          key="1"
          extra={genExtra(props?.data?.dataCardId)}
          style={{marginBottom:8}}
        >
          <Row gutter={16}>
            <ProgressCardDesc
              size={8}
              cardHeight={400}
              name="CHD Score"
              value={props?.data?.chdScore?.percentage}
              percent={"0%-100%"}
              // info={riskScores?.diseaseBasedRisk?.info}
              heading={"Top contributing Factors"}
              factors={diseasBasedRiskFactors}
              scoreFlag={props?.data?.chdScore?.chdScoreFlag}
            />
          </Row>
        </Panel>
      </Collapse>
    </>
  );
};

export default DiseasBasedRisk;
